import { useState } from 'react';

const CancellationPolicyPopup = ({ cancellationData, currencySymbol }) => {
    const [showPopup, setShowPopup] = useState(false);

    const formatCurrency = (amount) => {
        if (amount === 0) return `${currencySymbol} 0`;
        return `${currencySymbol} ${amount?.toFixed(2) || '0.00'}`;
    };

    const formatDateDisplay = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    const formatDateTime = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const freeCancellationPeriod = cancellationData?.find(item => item.am === 0);
    const hasFullRefund = cancellationData?.some(item => item.Isfullrefundallowed);

    return (
        <>
            <div className="text-right">
                <button
                    onClick={() => setShowPopup(true)}
                    className="text-blue-600 text-sm font-medium hover:text-blue-800 mt-1 underline"
                >
                    Cancellation Policy
                </button>
            </div>

            {showPopup && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-lg shadow-xl max-w-3xl w-full max-h-[90vh] overflow-hidden">
                        {/* Header */}
                        <div className="bg-white p-6 border-b border-gray-200">
                            <h3 className="text-xl font-semibold text-gray-800 text-center">Cancellation Policy</h3>
                        </div>

                        {/* Content */}
                        <div className="p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
                            {/* Main Table */}
                            <div className="bg-white border border-gray-300 rounded-lg overflow-hidden mb-6">
                                <table className="w-full border-collapse">
                                    <thead className="bg-gray-100">
                                        <tr>
                                            <th className="px-4 py-3 text-left font-semibold text-gray-700 border-b border-r border-gray-300">
                                                Cancellation on or After
                                            </th>
                                            <th className="px-4 py-3 text-left font-semibold text-gray-700 border-b border-r border-gray-300">
                                                Cancellation on or Before
                                            </th>
                                            <th className="px-4 py-3 text-left font-semibold text-gray-700 border-b border-gray-300">
                                                Cancellation Charges
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {cancellationData?.map((item, index) => (
                                            <tr key={index} className="hover:bg-gray-50">
                                                <td className="px-4 py-3 border-b border-r border-gray-300 text-gray-700">
                                                    {formatDateDisplay(item.fromddate)}
                                                </td>
                                                <td className="px-4 py-3 border-b border-r border-gray-300 text-gray-700">
                                                    {formatDateDisplay(item.todate)}
                                                </td>
                                                <td className="px-4 py-3 border-b border-gray-300 text-gray-700 font-medium">
                                                    {formatCurrency(item.am)}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* Policy Highlights */}
                            <div className="space-y-2 text-sm text-gray-700 bg-gray-50 p-4 rounded-lg border border-gray-200">
                                {freeCancellationPeriod && (
                                    <div className="flex items-center">
                                        <span className="text-green-500 mr-2 text-lg">✔</span>
                                        <span className="font-medium">
                                            Free Cancellation before {formatDateTime(freeCancellationPeriod.todate)}
                                        </span>
                                    </div>
                                )}

                                {hasFullRefund && (
                                    <div className="flex items-center">
                                        <span className="text-green-500 mr-2 text-lg">✔</span>
                                        <span className="font-medium">Full Refundable Allow</span>
                                    </div>
                                )}

                                <div className="text-gray-600 text-xs mt-3 pt-3 border-t border-gray-300">
                                    Cancellations are only allowed before the Check-In Time. All time mentioned above is in Destination Time.
                                </div>
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="flex justify-center p-4 border-t border-gray-200 bg-white">
                            <button
                                onClick={() => setShowPopup(false)}
                                className="px-8 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors font-medium"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default CancellationPolicyPopup;